import React from "react";
import Footer from "./Landing/components/Footer";
import styles from "./sass/subpage.module.scss";
import classNames from "classnames";
import { Typography } from "@mui/material";

const ImpactInvesting = (props) => {
  return (
    <>
      <div className={classNames(styles["subpage"], "container")}>
        <div className="row my-5">
          <div className="col-md-8 col-12">
            <Typography variant="h2">Thank you</Typography>
          </div>
        </div>
        <div className="row mb-5 justify-content-center">
          <div className="col-md-8 col-12">
            <Typography variant="body1">
              Your message has been sent! We will endeavour to reply to all emails within 48 business hours.
            </Typography>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default ImpactInvesting;
